import { RecordListOrderOption } from '../../../swagger/dto'

export const DateFilterRecord = [
    {
        title: 'По дате',
        value: RecordListOrderOption.CreatedAt,
    },
    {
        title: 'По названию',
        value: RecordListOrderOption.Title,
    },
]
